(function () {
  const STORAGE_KEY = 'ari_header_recent_searches';
  const MAX_RECENT = 5;
  const DEBOUNCE_MS = 200;
  let mobileSearchCloseLockUntil = 0;

  function canOpenMobileSearchOverlay() {
    return Date.now() > mobileSearchCloseLockUntil;
  }

  function lockMobileSearchOpenBriefly() {
    mobileSearchCloseLockUntil = Date.now() + 600;
  }

  function blurMobileNavSearchInputs() {
    document
      .querySelectorAll('.header-search--mobile-nav [data-header-search-input]')
      .forEach(function (input) {
        input.blur();
      });
  }

  function onReady(fn) {
    if (document.readyState !== 'loading') return fn();
    document.addEventListener('DOMContentLoaded', fn);
  }

  function readRecent() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      const parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed.filter(Boolean).slice(0, MAX_RECENT) : [];
    } catch {
      return [];
    }
  }

  function writeRecent(terms) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(terms.slice(0, MAX_RECENT)));
    } catch {
      /* ignore */
    }
  }

  function addRecent(term) {
    const trimmed = (term || '').trim();
    if (!trimmed) return;
    const next = [
      trimmed,
      ...readRecent().filter(function (t) {
        return t.toLowerCase() !== trimmed.toLowerCase();
      }),
    ];
    writeRecent(next);
  }

  function persistSearchQueryFromUrl() {
    try {
      const path = (location.pathname || '').replace(/\/+$/, '') || '/';
      if (path !== '/search' && !path.endsWith('/search')) return;
      const q = (new URL(location.href).searchParams.get('q') || '').trim();
      if (q) addRecent(q);
    } catch {
      /* ignore */
    }
  }

  function searchUrl(base, term) {
    const url = new URL(base || '/search', location.origin);
    url.searchParams.set('q', term);
    url.searchParams.set('options[prefix]', 'last');
    return url.toString();
  }

  function hasQuery(input) {
    return Boolean(input && input.value && input.value.trim().length > 0);
  }

  function setBodyActive(active, options) {
    if (options && options.isOverlay) return;
    document.body.classList.toggle('header-search-dropdown-active', active);
  }

  function debounce(fn, wait) {
    let timer;
    return function () {
      const args = arguments;
      const ctx = this;
      clearTimeout(timer);
      timer = setTimeout(function () {
        fn.apply(ctx, args);
      }, wait);
    };
  }

  function decodeDataTemplate(value) {
    if (!value || value.indexOf('&') === -1) return value;
    var el = document.createElement('textarea');
    el.innerHTML = value;
    return el.value;
  }

  function applyTemplate(template, terms, count) {
    return decodeDataTemplate(template).replace('__TERMS__', terms).replace('__COUNT__', String(count));
  }

  function isMobileViewport() {
    return window.matchMedia('(max-width: 768px)').matches;
  }

  function isTouchDevice() {
    return window.matchMedia('(hover: none) and (pointer: coarse)').matches;
  }

  const PREDICTIVE_SEARCH_API_PATH = '/en/search/suggest';

  /** Predictive JSON API is English-only; strip /th (etc.) and force /en. */
  function resolvePredictiveSearchApiUrl(url) {
    const raw = (url || '').trim() || PREDICTIVE_SEARCH_API_PATH;
    try {
      const parsed = new URL(raw, location.origin);
      let path = parsed.pathname.replace(/\.json$/i, '');
      path = path.replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/|$)/i, '');
      if (!path.startsWith('/')) path = '/' + path;
      if (!path.startsWith('/en/')) path = '/en' + (path === '/' ? '/search/suggest' : path);
      if (path.indexOf('/search/suggest') === -1) path = PREDICTIVE_SEARCH_API_PATH;
      return path;
    } catch {
      return PREDICTIVE_SEARCH_API_PATH;
    }
  }

  function buildSearchCountApiUrl(term) {
    const url = new URL('/en/search', location.origin);
    url.searchParams.set('view', 'count');
    url.searchParams.set('q', term);
    url.searchParams.set('type', 'product');
    url.searchParams.set('options[prefix]', 'last');
    return url.pathname + url.search;
  }

  function dedupeMobileSearchOverlays() {
    const overlays = Array.from(document.querySelectorAll('#mobile-search-overlay'));
    if (overlays.length <= 1) return overlays[0] || null;

    const keeper =
      overlays.find(function (o) {
        return o.parentElement === document.body;
      }) ||
      overlays.find(function (o) {
        const root = o.querySelector('[data-header-search]');
        return root && root.__ariHeaderSearch;
      }) ||
      overlays[overlays.length - 1];

    overlays.forEach(function (o) {
      if (o !== keeper) o.remove();
    });

    return keeper;
  }

  function getMobileSearchOverlay() {
    return dedupeMobileSearchOverlays();
  }

  function bindMobileSearchCloseControls() {
    const overlay = getMobileSearchOverlay();
    if (!overlay || overlay.dataset.ariCloseBound === 'true') return;
    overlay.dataset.ariCloseBound = 'true';

    overlay.addEventListener(
      'click',
      function (e) {
        const closeTrigger = e.target.closest('[data-action="close-mobile-search"]');
        if (!closeTrigger || !overlay.contains(closeTrigger)) return;
        e.preventDefault();
        closeMobileSearchOverlay();
      },
      true
    );
  }

  function getOverlayHeaderSearch() {
    const overlay = getMobileSearchOverlay();
    if (!overlay) return null;
    const root = overlay.querySelector('[data-header-search]');
    return root && root.__ariHeaderSearch ? root.__ariHeaderSearch : null;
  }

  function isMobileMenuOpen() {
    const headerMain = document.querySelector('header .main-header');
    return Boolean(headerMain && headerMain.classList.contains('menu-open'));
  }

  function ensureMobileSearchOverlayPortal() {
    const overlay = getMobileSearchOverlay();
    if (!overlay) return null;
    if (overlay.parentElement !== document.body) {
      document.body.appendChild(overlay);
    }
    const panel = overlay.querySelector('.mobile-search-overlay__panel');
    if (panel) {
      overlay.appendChild(panel);
    }
    return overlay;
  }

  function lockPageScrollForOverlay() {
    const overlay = getMobileSearchOverlay();
    if (overlay && overlay.dataset.ariBodyOverflowSaved === undefined) {
      overlay.dataset.ariBodyOverflowSaved = document.body.style.overflow || '';
    }

    document.body.classList.remove('mobile-search-overlay-active', 'header-search-dropdown-active');
    document.body.style.removeProperty('overflow');

    document.documentElement.setAttribute('data-mobile-search-overlay', '');

    if (!isMobileViewport()) {
      document.documentElement.setAttribute('scroll-lock', '');
    }
  }

  function unlockPageScrollForOverlay() {
    const overlay = getMobileSearchOverlay();
    document.documentElement.removeAttribute('scroll-lock');
    document.documentElement.removeAttribute('data-mobile-search-overlay');

    if (overlay && overlay.dataset.ariBodyOverflowSaved !== undefined) {
      document.body.style.overflow = isMobileMenuOpen() ? 'hidden' : overlay.dataset.ariBodyOverflowSaved;
      delete overlay.dataset.ariBodyOverflowSaved;
    }
  }

  function openMobileSearchOverlay(source) {
    if (!canOpenMobileSearchOverlay()) return;

    const overlay = ensureMobileSearchOverlayPortal();
    if (!overlay) return;

    blurMobileNavSearchInputs();
    bindMobileSearchCloseControls();

    const alreadyOpen = overlay.classList.contains('is-open');

    lockPageScrollForOverlay();
    overlay.classList.add('is-open', 'has-dropdown');
    overlay.setAttribute('aria-hidden', 'false');

    const overlayInput = overlay.querySelector('[data-header-search-input]');
    const dropdown = overlay.querySelector('.header-search-dropdown');
    const instance = getOverlayHeaderSearch();

    if (dropdown) {
      dropdown.hidden = false;
      dropdown.removeAttribute('hidden');
    }

    if (instance) {
      if (!hasQuery(instance.input)) {
        instance.showEmptyMode();
        instance.renderRecent();
      } else {
        instance.showPredictiveMode();
      }
      instance.open();
    }

    void overlay.offsetHeight;

    if (window.visualViewport) {
      const reflowOnViewport = function () {
        void overlay.offsetHeight;
        window.visualViewport.removeEventListener('resize', reflowOnViewport);
      };
      window.visualViewport.addEventListener('resize', reflowOnViewport, { passive: true });
    }

    if (overlayInput && !alreadyOpen && !isTouchDevice()) {
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          overlayInput.focus({ preventScroll: true });
        });
      });
    }
  }

  function closeMobileSearchOverlay() {
    const overlay = getMobileSearchOverlay();
    if (!overlay) return;
    lockMobileSearchOpenBriefly();

    overlay.classList.remove('is-open', 'has-dropdown');
    overlay.setAttribute('aria-hidden', 'true');
    unlockPageScrollForOverlay();
    document.body.classList.remove('header-search-dropdown-active');

    const overlayInput = overlay.querySelector('[data-header-search-input]');
    if (overlayInput) overlayInput.blur();
    blurMobileNavSearchInputs();

    if (document.activeElement && document.activeElement !== document.body) {
      document.activeElement.blur();
    }

    document.querySelectorAll('[data-header-search]').forEach(function (root) {
      const dropdown = root.querySelector('.header-search-dropdown');
      if (dropdown) dropdown.hidden = true;
      const input = root.querySelector('[data-header-search-input]');
      if (input) input.setAttribute('aria-expanded', 'false');
    });
  }

  window.ariOpenMobileSearchOverlay = openMobileSearchOverlay;
  window.ariCloseMobileSearchOverlay = closeMobileSearchOverlay;

  class HeaderSearch {
    constructor(root) {
      this.root = root;
      this.form = root.querySelector('[data-header-search-form]');
      this.input = root.querySelector('[data-header-search-input]');
      this.clearBtn = root.querySelector('[data-header-search-clear]');
      this.dropdown = root.querySelector('.header-search-dropdown');
      this.emptyState = root.querySelector('[data-header-search-empty]');
      this.predictivePanel = root.querySelector('[data-header-search-predictive]');
      this.recentSection = root.querySelector('[data-header-search-recent-section]');
      this.recentList = root.querySelector('[data-header-search-recent-list]');
      this.queryList = root.querySelector('[data-header-search-query-list]');
      this.productList = root.querySelector('[data-header-search-product-list]');
      this.queriesDivider = root.querySelector('[data-header-search-queries-divider]');
      this.footerDivider = root.querySelector('[data-header-search-footer-divider]');
      this.viewAllLink = root.querySelector('[data-header-search-view-all]');
      this.viewAllText = root.querySelector('[data-header-search-view-all-text]');
      this.noResults = root.querySelector('[data-header-search-no-results]');
      this.loadingEl = root.querySelector('[data-header-search-predictive-loading]');
      this.statusEl = root.querySelector('[data-header-search-predictive-status]');

      this.predictiveUrl = resolvePredictiveSearchApiUrl(
        root.dataset.predictiveUrl ||
          (window.Theme && window.Theme.routes && window.Theme.routes.predictive_search_url) ||
          PREDICTIVE_SEARCH_API_PATH
      );
      this.searchBaseUrl =
        root.dataset.searchUrl || (window.Theme && window.Theme.routes && window.Theme.routes.search_url) || '/search';
      this.queriesLimit = parseInt(root.dataset.queriesLimit || '5', 10);
      this.productsLimit = parseInt(root.dataset.productsLimit || '5', 10);
      this.viewAllTemplate = decodeDataTemplate(
        root.getAttribute('data-view-all-template') || root.dataset.viewAllTemplate || "View all results for '__TERMS__' (__COUNT__)"
      );
      this.noResultsTemplate = decodeDataTemplate(
        root.getAttribute('data-no-results-template') || root.dataset.noResultsTemplate || "No results found for '__TERMS__'"
      );

      this.isOverlay = root.closest('#mobile-search-overlay') != null;
      this.isMobileNav = !this.isOverlay && root.classList.contains('header-search--mobile-nav');
      this.fetchController = null;
      this.countController = null;
      this.lastFetchedTerm = '';

      this.debouncedPredictive = debounce(this.runPredictiveSearch.bind(this), DEBOUNCE_MS);

      root.__ariHeaderSearch = this;
      this.init();
    }

    init() {
      if (!this.input || !this.dropdown) return;

      if (this.isMobileNav) {
        this.initMobileNavTrigger();
        return;
      }

      this.renderRecent();
      this.syncClearButton();

      this.input.addEventListener('focus', this.onFocus.bind(this));
      this.input.addEventListener('click', this.onFocus.bind(this));
      this.input.addEventListener('input', this.onInput.bind(this));
      this.input.addEventListener('keydown', this.onKeydown.bind(this));

      if (this.clearBtn) {
        this.clearBtn.addEventListener('click', this.onClear.bind(this));
      }

      if (this.form) {
        this.form.addEventListener('submit', this.onSubmit.bind(this));
      }

      this.root.addEventListener('click', function (e) {
        if (e.target.closest('[data-action="close-mobile-search"]')) return;

        const popular = e.target.closest('[data-header-search-popular]');
        if (popular) {
          e.preventDefault();
          const term = popular.getAttribute('data-search-term') || popular.textContent.trim();
          if (term) {
            addRecent(term);
            window.location.href = searchUrl(this.searchBaseUrl, term);
          }
          return;
        }

        const recent = e.target.closest('[data-header-search-recent]');
        if (recent) {
          e.preventDefault();
          const term = recent.getAttribute('data-search-term') || recent.textContent.trim();
          if (term) {
            addRecent(term);
            window.location.href = searchUrl(this.searchBaseUrl, term);
          }
          return;
        }

        const query = e.target.closest('[data-header-search-query]');
        if (query) {
          e.preventDefault();
          const term = query.getAttribute('data-search-term');
          if (term) {
            addRecent(term);
            window.location.href = searchUrl(this.searchBaseUrl, term);
          }
          return;
        }

        const viewAll = e.target.closest('[data-header-search-view-all]');
        if (viewAll) {
          const term = viewAll.getAttribute('data-search-term') || (this.input && this.input.value.trim());
          if (term) addRecent(term);
        }
      }.bind(this));

      if (!this.isOverlay) {
        document.addEventListener('pointerdown', this.onDocumentPointerDown.bind(this));
      }
    }

    initMobileNavTrigger() {
      this.dropdown.hidden = true;
      this.input.setAttribute('aria-expanded', 'false');
      this.input.setAttribute('readonly', 'readonly');
      this.input.setAttribute('inputmode', 'none');
      this.input.setAttribute('aria-haspopup', 'dialog');
      this.input.setAttribute('aria-controls', 'mobile-search-overlay');

      const redirectToOverlay = function (e) {
        if (!isMobileViewport()) return;
        if (!canOpenMobileSearchOverlay()) return;
        e.preventDefault();
        e.stopPropagation();
        this.input.blur();
        openMobileSearchOverlay('nav-input');
      }.bind(this);

      /* Mobile viewport: click only — focus would re-open overlay right after close */
      if (isMobileViewport()) {
        this.input.addEventListener('click', redirectToOverlay);
      } else {
        this.input.addEventListener('focus', redirectToOverlay);
        this.input.addEventListener('click', redirectToOverlay);
      }

      if (this.form) {
        this.form.addEventListener('submit', function (e) {
          if (!isMobileViewport()) return;
          e.preventDefault();
          openMobileSearchOverlay('nav-submit');
        });
      }
    }

    onDocumentPointerDown(e) {
      if (this.isOverlay || isMobileViewport()) return;
      if (!this.dropdown || this.dropdown.hidden) return;
      if (this.root.contains(e.target)) return;
      this.close();
    }

    onFocus() {
      if (this._focusHandling) return;
      this._focusHandling = true;
      try {
        if (hasQuery(this.input)) {
          this.showPredictiveMode();
          this.open();
          this.debouncedPredictive();
        } else {
          this.showEmptyMode();
          this.renderRecent();
          this.open();
        }
      } finally {
        this._focusHandling = false;
      }
    }

    onInput() {
      this.syncClearButton();
      const term = this.input.value.trim();

      if (!term) {
        this.abortFetches();
        this.showEmptyMode();
        this.renderRecent();
        this.open();
        return;
      }

      this.showPredictiveMode();
      this.open();
      this.debouncedPredictive();
    }

    onClear(e) {
      e.preventDefault();
      this.input.value = '';
      this.syncClearButton();
      this.abortFetches();
      this.showEmptyMode();
      this.renderRecent();
      this.open();
      this.input.focus();
    }

    onKeydown(e) {
      if (e.key === 'Enter') {
        const value = (this.input.value || '').trim();
        if (value) addRecent(value);
      }
      if (e.key === 'Escape') {
        if (this.isOverlay) {
          closeMobileSearchOverlay();
          return;
        }
        this.close();
        this.input.blur();
      }
    }

    onSubmit() {
      addRecent(this.input.value);
      this.close();
    }

    syncClearButton() {
      if (!this.clearBtn) return;
      this.clearBtn.hidden = !hasQuery(this.input);
    }

    abortFetches() {
      if (this.fetchController) {
        this.fetchController.abort();
        this.fetchController = null;
      }
      if (this.countController) {
        this.countController.abort();
        this.countController = null;
      }
    }

    showEmptyMode() {
      if (this.dropdown) {
        this.dropdown.classList.remove('header-search-dropdown--predictive');
      }
      if (this.emptyState) this.emptyState.hidden = false;
      if (this.predictivePanel) this.predictivePanel.hidden = true;
    }

    showPredictiveMode() {
      if (this.dropdown) {
        this.dropdown.classList.add('header-search-dropdown--predictive');
      }
      if (this.emptyState) this.emptyState.hidden = true;
      if (this.predictivePanel) this.predictivePanel.hidden = false;
    }

    renderRecent() {
      if (!this.recentList || !this.recentSection) return;
      const terms = readRecent();
      const heading = this.recentSection.querySelector('[data-header-search-recent-heading]');
      this.recentList.innerHTML = '';

      if (!terms.length) {
        this.recentSection.hidden = true;
        if (heading) heading.remove();
        return;
      }

      this.recentSection.hidden = false;
      if (!heading) {
        const h3 = document.createElement('h3');
        h3.className = 'header-search-dropdown__heading';
        h3.setAttribute('data-header-search-recent-heading', '');
        h3.textContent = this.recentSection.dataset.recentHeading || 'Recently Searched';
        this.recentSection.insertBefore(h3, this.recentList);
      }
      terms.forEach(
        function (term) {
          const li = document.createElement('li');
          const link = document.createElement('a');
          link.href = searchUrl(this.searchBaseUrl, term);
          link.className = 'header-search-dropdown__recent-item';
          link.setAttribute('data-header-search-recent', '');
          link.setAttribute('data-search-term', term);
          link.textContent = term;
          li.appendChild(link);
          this.recentList.appendChild(li);
        }.bind(this)
      );
    }

    hasEmptyContent() {
      const hasPopular = Boolean(this.dropdown.querySelector('.header-search-dropdown__section--popular'));
      const hasSuggestions = Boolean(this.dropdown.querySelector('.header-search-dropdown__suggestions-list'));
      const hasRecent = this.recentSection && !this.recentSection.hidden;
      return hasPopular || hasSuggestions || hasRecent;
    }

    open() {
      const isPredictive = hasQuery(this.input);

      if (this.isOverlay) {
        if (!isPredictive) {
          this.renderRecent();
        }

        this.dropdown.hidden = false;
        this.input.setAttribute('aria-expanded', 'true');
        setBodyActive(true, { isOverlay: true });

        const overlay = getMobileSearchOverlay();
        if (overlay) overlay.classList.add('has-dropdown');

        return;
      }

      if (!isPredictive) {
        this.renderRecent();
      }

      if (!isPredictive && !this.hasEmptyContent()) {
        this.dropdown.hidden = true;
        this.input.setAttribute('aria-expanded', 'false');
        return;
      }

      this.dropdown.hidden = false;
      this.input.setAttribute('aria-expanded', 'true');
      setBodyActive(true);
    }

    close() {
      if (!this.dropdown) return;
      this.dropdown.hidden = true;
      this.input.setAttribute('aria-expanded', 'false');
      setBodyActive(false, { isOverlay: this.isOverlay });
      this.abortFetches();

      if (this.isOverlay) {
        const overlay = getMobileSearchOverlay();
        if (overlay) overlay.classList.remove('has-dropdown');
      }
    }

    setLoading(loading) {
      if (this.loadingEl) this.loadingEl.hidden = !loading;
    }

    async runPredictiveSearch() {
      const term = this.input.value.trim();
      if (!term) return;

      this.lastFetchedTerm = term;
      this.abortFetches();
      this.fetchController = new AbortController();
      const signal = this.fetchController.signal;

      this.setLoading(true);
      this.clearPredictiveResults();

      try {
        const data = await this.fetchPredictive(term, signal);
        if (signal.aborted || this.input.value.trim() !== term) return;

        const resources = (data && data.resources) || {};
        const results = resources.results || resources;
        const queries = (results.queries || []).slice(0, this.queriesLimit);
        const products = (results.products || []).slice(0, this.productsLimit);

        this.renderPredictiveResults(term, queries, products);
        this.fetchResultCount(term);
      } catch (err) {
        if (err && err.name === 'AbortError') return;
        this.renderPredictiveResults(term, [], []);
      } finally {
        if (!signal.aborted && this.input.value.trim() === term) {
          this.setLoading(false);
        }
      }
    }

    fetchPredictive(term, signal) {
      const apiPath = resolvePredictiveSearchApiUrl(this.predictiveUrl);
      const jsonUrl = apiPath.endsWith('.json') ? apiPath : apiPath + '.json';
      const url = new URL(jsonUrl, location.origin);
      url.searchParams.set('q', term);
      url.searchParams.set('resources[type]', 'query,product');
      url.searchParams.set('resources[limit]', String(Math.max(this.queriesLimit, this.productsLimit)));
      url.searchParams.set('resources[limit_scope]', 'each');

      return fetch(url, { signal }).then(function (res) {
        if (!res.ok) throw new Error('Predictive search failed');
        return res.json();
      });
    }

    fetchResultCount(term) {
      if (this.countController) this.countController.abort();
      this.countController = new AbortController();
      const signal = this.countController.signal;

      const countUrl = buildSearchCountApiUrl(term);

      fetch(countUrl, { signal })
        .then(function (res) {
          if (!res.ok) throw new Error('Count failed');
          return res.json();
        })
        .then(
          function (data) {
            if (signal.aborted || this.input.value.trim() !== term) return;
            const count = Number.isFinite(Number(data && data.results_count)) ? Number(data.results_count) : 0;
            this.updateViewAll(term, count);
          }.bind(this)
        )
        .catch(function () {
          /* keep view-all without count */
        });
    }

    clearPredictiveResults() {
      if (this.queryList) this.queryList.innerHTML = '';
      if (this.productList) this.productList.innerHTML = '';
      if (this.queriesDivider) this.queriesDivider.hidden = true;
      if (this.footerDivider) this.footerDivider.hidden = true;
      if (this.viewAllLink) this.viewAllLink.hidden = true;
      if (this.noResults) this.noResults.hidden = true;
    }

    renderPredictiveResults(term, queries, products) {
      this.clearPredictiveResults();

      const hasQueries = queries.length > 0;
      const hasProducts = products.length > 0;

      if (!hasQueries && !hasProducts) {
        if (this.noResults) {
          this.noResults.textContent = applyTemplate(this.noResultsTemplate, term, 0);
          this.noResults.hidden = false;
        }
        if (this.statusEl) {
          this.statusEl.textContent = applyTemplate(this.noResultsTemplate, term, 0);
        }
        return;
      }

      if (this.queryList && hasQueries) {
        queries.forEach(
          function (query) {
            const text = query.text || query.styled_text || '';
            const li = document.createElement('li');
            const link = document.createElement('a');
            link.href = query.url || searchUrl(this.searchBaseUrl, text);
            link.className = 'header-search-dropdown__query-item';
            link.setAttribute('data-header-search-query', '');
            link.setAttribute('data-search-term', text);

            const icon = document.createElement('span');
            icon.className = 'header-search-dropdown__icon header-search-dropdown__icon--query';
            icon.setAttribute('aria-hidden', 'true');
            icon.innerHTML =
              '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" fill="#909090"/></svg>';

            const label = document.createElement('span');
            label.className = 'header-search-dropdown__query-label';
            label.textContent = text;

            link.appendChild(icon);
            link.appendChild(label);
            li.appendChild(link);
            this.queryList.appendChild(li);
          }.bind(this)
        );
        if (this.queriesDivider) this.queriesDivider.hidden = !hasProducts;
      }

      if (this.productList && hasProducts) {
        products.forEach(
          function (product) {
            const li = document.createElement('li');
            const link = document.createElement('a');
            link.href = product.url || '#';
            link.className = 'header-search-dropdown__product-item';

            const media = document.createElement('div');
            media.className = 'header-search-dropdown__product-media';
            if (product.featured_image && product.featured_image.url) {
              const img = document.createElement('img');
              img.src = product.featured_image.url;
              img.alt = product.featured_image.alt || product.title || '';
              img.width = 96;
              img.height = 96;
              img.loading = 'lazy';
              media.appendChild(img);
            }

            const info = document.createElement('div');
            info.className = 'header-search-dropdown__product-info';

            const title = document.createElement('p');
            title.className = 'header-search-dropdown__product-title';
            title.textContent = product.title || '';

            const price = document.createElement('p');
            price.className = 'header-search-dropdown__product-price';
            price.innerHTML = product.price || '';

            info.appendChild(title);
            info.appendChild(price);
            link.appendChild(media);
            link.appendChild(info);
            li.appendChild(link);
            this.productList.appendChild(li);
          }.bind(this)
        );
      }

      if (this.viewAllLink && (hasQueries || hasProducts)) {
        this.viewAllLink.href = searchUrl(this.searchBaseUrl, term);
        this.viewAllLink.hidden = false;
        this.viewAllLink.setAttribute('data-search-term', term);
        this.updateViewAll(term, null);
        if (this.footerDivider) this.footerDivider.hidden = false;
      }

      if (this.statusEl) {
        const count = queries.length + products.length;
        this.statusEl.textContent = count + ' suggestions for ' + term;
      }
    }

    updateViewAll(term, count) {
      if (!this.viewAllText || !this.viewAllLink) return;
      const displayCount = count === null || count === undefined ? '…' : count;
      this.viewAllText.textContent = applyTemplate(this.viewAllTemplate, term, displayCount);
    }
  }

  onReady(function () {
    document.addEventListener(
      'click',
      function (e) {
        const overlay = getMobileSearchOverlay();
        if (!overlay || overlay.getAttribute('aria-hidden') === 'true') return;
        const trigger = e.target.closest('[data-action="close-mobile-search"]');
        if (!trigger || !overlay.contains(trigger)) return;
        e.preventDefault();
        closeMobileSearchOverlay();
      },
      true
    );
    persistSearchQueryFromUrl();
    ensureMobileSearchOverlayPortal();
    bindMobileSearchCloseControls();
    document.querySelectorAll('[data-header-search]').forEach(function (root) {
      if (root.__ariHeaderSearch) return;
      new HeaderSearch(root);
    });

    document.addEventListener(
      'submit',
      function (e) {
        const form = e.target;
        if (!(form instanceof HTMLFormElement)) return;
        const action = form.getAttribute('action') || '';
        if (!action.includes('/search')) return;
        const input = form.querySelector('input[name="q"]');
        const term = input && input.value ? input.value.trim() : '';
        if (term) addRecent(term);
      },
      true
    );

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      const overlay = getMobileSearchOverlay();
      if (overlay && overlay.classList.contains('is-open')) {
        closeMobileSearchOverlay();
      }
    });

    document.addEventListener('shopify:section:load', function () {
      getMobileSearchOverlay();
      ensureMobileSearchOverlayPortal();
      bindMobileSearchCloseControls();
    });
  });
})();
